import { render, staticRenderFns } from "./all-tests.vue?vue&type=template&id=39ac1a21&scoped=true&"
import script from "./all-tests.vue?vue&type=script&lang=js&"
export * from "./all-tests.vue?vue&type=script&lang=js&"
import style0 from "./all-tests.vue?vue&type=style&index=0&id=39ac1a21&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ac1a21",
  null
  
)

export default component.exports